import { z, type ZodType } from "zod";

export const coerceBoolean: ZodType<boolean> = z
	.union([
		z.enum(["False", "false", "0"]).transform(() => false),
		z.boolean(),
		z.string(),
		z.number(),
		z.undefined(),
		z.null(),
	])
	.pipe(z.coerce.boolean());
